import type { CSSProperties } from 'react';
import { T } from '@territory/tokens';
const role = (name: string, fallback: string): string => `var(--rv-${name}, ${fallback})`;
/* Bare native resource controls keep the shipped OS picker and caller style overrides. */
export function marketingResourceFieldStyle(): CSSProperties {
  return {
    width: '100%', boxSizing: 'border-box', padding: '11px 14px', borderRadius: 10,
    background: role('resource-field-fill', T.surface), border: `1px solid ${role('border', T.separator)}`,
    color: role('text', T.label),
    fontFamily: role('resource-field-font', T.font), fontSize: '0.95rem', outline: 'none',
  };
}

/* Keep the variant attribute last so selector engines reject unrelated fields before resolving :has. */
export const MARKETING_RESOURCE_SELECT_CSS = `[data-rv-marketing-field="resource-select"] { --rv-resource-field-ink: ${role('text', T.label)}; }
:has(option:checked[value=""])[data-rv-marketing-field="resource-select"] { --rv-resource-field-ink: ${role('text-sec', T.labelSec)}; }`;
